import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';
import { IGeneralPractitionerWithOfficesSummary } from 'gen/ApiClient';
import React from 'react';

export const GeneralPractitionersCacheContext = React.createContext<IPreloadCacheContext<IGeneralPractitionerWithOfficesSummary[]>>(undefined as any);
